export default __webpack_public_path__ + "static/CRUCES_DOS-b4da11bfe21c23ff65d5ec526d112a59.jpg";